export default __webpack_public_path__ + "static/media/1834.a1284edf.png";